/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/table_medium'
export default icon
